import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Card, Divider, Radio, Hidden } from '@material-ui/core';
import classNames from 'classnames';
import { isEmpty, isArray } from 'lodash';
import { ADGMPagination, ADGMImage, ADGMItemDetails } from 'aurora-components';
import { NoResult } from 'aurora-section-components';

import styles from './styles';

function ExistingRepresentative({
  classes,
  locale,
  isEditFlow,
  representativesData,
  selectedRepresentative,
  isRepDetailsFetched,
  isPartyTypeCompany,
  currentPage,
  onRepresentativeSelectHandler,
  onPageChangeHandler,
}) {
  const handlePageChange = page => {
    if (+page === currentPage) return;
    onPageChangeHandler(+page);
  };

  const dataKey = isEditFlow ? 'userId' : 'id';
  return (
    <>
      {isRepDetailsFetched && (!isArray(representativesData?.data) || isEmpty(representativesData?.data)) && (
        <NoResult
          title={isPartyTypeCompany ? 'no_representative_found_message' : 'no_existing_representative_found_message'}
          customClasses={{ container: classes.noResultContainer }}
          iconName='nodata.svg'
        />
      )}
      {isArray(representativesData?.data) && !isEmpty(representativesData?.data) && (
        <>
          <div className={classes.representativeCardsList}>
            {representativesData?.data?.map(rep => (
              <Card
                key={rep?.id}
                className={classNames(classes.representativeCard, {
                  [classes.selectedRepresentativeCard]: rep?.id === selectedRepresentative?.[dataKey],
                })}
                onClick={() => onRepresentativeSelectHandler(rep)}
              >
                <div className={classes.nameAndIconHolder}>
                  <Radio
                    className={classes.representativeCardRadioButton}
                    checked={!!(selectedRepresentative && rep?.id === selectedRepresentative?.[dataKey])}
                  />
                  <ADGMImage name='user_profileV3.svg' alt='add-representative' />
                  <div className={classes.nameHolder}>
                    <ADGMItemDetails
                      label='Name'
                      value={locale === 'en' ? rep?.nameEn || rep?.nameAr : rep?.nameAr || rep?.nameEn}
                    />
                  </div>
                </div>
                <Hidden smDown>
                  <Divider className={classes.divider} />
                </Hidden>
                <div className={classes.representativeDetailsHolder}>
                  <div className={classes.representativeDetail}>
                    <ADGMItemDetails label='emirates_ID' value={rep?.eid} />
                  </div>
                  <div className={classes.representativeDetail}>
                    <ADGMItemDetails label='email' value={rep?.email} />
                  </div>
                  <div className={classes.representativeDetail}>
                    <ADGMItemDetails label='phone_number' value={rep?.phoneNo} />
                  </div>
                </div>
              </Card>
            ))}
          </div>
          <ADGMPagination
            totalPages={representativesData?.totalPages}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            customClasses={{ container: classes.pagination }}
          />
        </>
      )}
    </>
  );
}

ExistingRepresentative.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  isEditFlow: PropTypes.bool.isRequired,
  representativesData: PropTypes.object.isRequired,
  selectedRepresentative: PropTypes.object.isRequired,
  isRepDetailsFetched: PropTypes.bool.isRequired,
  isPartyTypeCompany: PropTypes.bool.isRequired,
  currentPage: PropTypes.number.isRequired,
  onRepresentativeSelectHandler: PropTypes.func.isRequired,
  onPageChangeHandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(ExistingRepresentative);
